import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  standalone: true,
  template: `
    <div class="flex flex-col items-center justify-center min-h-screen bg-red-50 text-red-800">
      <div class="flex items-center space-x-4">
        <img src="https://cdn-icons-png.flaticon.com/512/753/753345.png" alt="Error Icon" class="w-12 h-12" />
        <h1 class="text-3xl font-bold">Integration Error</h1>
      </div>
      <p class="mt-4 text-lg">There was an issue with the integration. Please try again.</p>
      @if (errorCode) {
        <p class="mt-2 text-sm font-medium">Error Code: {{ errorCode }}</p>
      }
      <div class="flex space-x-4 mt-6">
        <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Instagram" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/145/145807.png" alt="LinkedIn" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="Google" class="w-10 h-10" />
      </div>
      <button (click)="goHome()" class="mt-8 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Go to Home</button>
    </div>
  `,
  styles: [],
})
export class ErrorComponent implements OnInit {
  errorCode: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.errorCode = params.get('code');
    });
  }

  goHome() {
    window.location.href = '/';
  }
}